import PraisoServices from "./PraisoServices";
import { getToken, getAPIResponse, setAPIResponse } from "./LocalStorageService";

export const CeStatsAPI = async (params) => {
  let ApiUrl = `campaign/stats`;

  if (params.impersonationid) {
    ApiUrl = `${ApiUrl}?impersonationId=${params.impersonationid}`;
  }
  const token = getToken()
  try {
    const data = getAPIResponse(ApiUrl);
    if (data !== null) {
      return data;
    }
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {},
      {},
      {
        Authorization: `Bearer ${token}`
      }
    );
    try {
      setAPIResponse(ApiUrl, response, 50000);
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const CeListAPI = async (filterParams) => {
  const ApiUrl = `campaign/user-list/${filterParams.statId}`;
  const token = getToken()
  try {
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {},
      {
        ...filterParams
      },
      {
        Authorization: `Bearer ${token}`
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const CeTableViewAPI = async (filterParams) => {
  // const ApiUrl = `insights/wol/${filterParams.statId}`;
  const ApiUrl = ''
  const token = getToken()
  try {
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {},
      {
        ...filterParams
      },
      {
        Authorization: `Bearer ${token}`
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const ceStats = async (params) => {
  const data = await CeStatsAPI(params);
  return data;
  // if (data.status.code !== 0 && data.status.code !== 200 && data.status.code !== 201) {
  //   return data;
  // } else {
  //   return data;
  // }
};

export const ceList = async (filterParams) => {
  const data = await CeListAPI(filterParams);
  return data;
  // if (data.status.code !== 0 && data.status.code !== 200 && data.status.code !== 201) {
  //   return data;
  // } else {
  //   return data;
  // }
};
